import { Stack, SxProps, Theme, Typography } from '@mui/material';
import type { IWorkspaceUser } from 'src/@types/workspace-info';

type Props = {
  sx?: SxProps<Theme>;
  user: Pick<IWorkspaceUser, 'customStatus'>;
};

export const UserCustomStatus = ({ user, sx }: Props) => {
  const isOnlyText = !user.customStatus?.icon;
  const isOnlyIcon = !user.customStatus?.text;

  return (
    <Stack
      direction="row"
      spacing={1}
      alignItems="center"
      sx={{
        ...sx,
        justifyContent: isOnlyIcon || isOnlyText ? 'flex-start' : '',
      }}
    >
      {!isOnlyText && <em-emoji shortcodes={user.customStatus?.icon} />}
      {!isOnlyIcon && (
        <Typography
          variant="body2"
          sx={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            maxWidth: '100%',
          }}
        >
          {user.customStatus?.text}
        </Typography>
      )}
    </Stack>
  );
};
